import React from 'react';
import { Link } from 'react-router-dom';
import { useChatContext } from 'stream-chat-react';
import { buildRoute } from 'utils/routes';
import type { ChatThreadType, Maybe } from 'graphql/types';

const ChatItem = ({ title, to }: { title: string; to: string }) => {
  return (
    <div className="overflow-hidden rounded shadow bg-white px-4 py-5 border-b border-slate-200 flex justify-between items-center">
      <h3 className="text-lg leading-6 font-medium text-slate-900">{title}</h3>
      <Link to={to}>
        <button
          type="button"
          className="inline-flex items-center px-4 py-2 border border-slate-300 text-sm leading-5 font-medium rounded text-slate-700 bg-white focus:outline-none focus:ring-blue focus:border-blue-300 active:text-slate-800 active:bg-white transition duration-150 ease-in-out"
        >
          View chat
        </button>
      </Link>
    </div>
  );
};

type ChatThread = {
  __typename?: 'ChatThread';
  id: string;
  type: ChatThreadType;
};

export const ChatSection = ({
  customer,
}: {
  customer: {
    id: string;
    chatThreads?: Maybe<Array<ChatThread>>;
  };
}): React.ReactElement | null => {
  const { client } = useChatContext();

  if (!customer.chatThreads?.length || !client) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      {customer.chatThreads
        .filter((t) => ['HEALTH_COACH', 'ASSISTANT'].includes(t.type))
        .map((t) => {
          let title;
          switch (t.type) {
            case 'ASSISTANT':
              title = 'Assistant Chat Thread';
              break;
            case 'HEALTH_COACH':
              title = 'Health Coach Chat Thread';
              break;
            default:
              throw new Error('unexpected thread type');
          }

          return (
            <ChatItem
              key={t.id}
              title={title}
              to={buildRoute.thread(customer.id, t.id)}
            />
          );
        })}
    </div>
  );
};
